import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { GetIcon } from "../icons/GetIcon.js";
import { SearchResultsMessage } from "./SearchResultsMessage.jsx";

export default class QueryField extends React.Component {
  constructor(props) {
    super(props);

    let { q } = props;

    this.state = {
      focused: false,
      length: q ? q.length : 0,
      terms_length: q ? q.split(" ").length : 0
    };
  }

  onBlur = (e) => {
    let { length } = this.state;

    this.setState({
      focused: length > 0 ? true : false
    });
  }

  onFocus = () => {
    this.setState({
      focused: true
    });
  }

  handleChange = (event) => {
    const 
      keyword = this.keywordInput.value,
      terms_length = keyword.split(" ").length;

    this.setState({
      length: this.keywordInput.value.length,
      terms_length: terms_length
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { handleUpdate } = this.props;
    const terms = this.keywordInput.value.split(" ").splice(0,  50).join(" ");

    this.setState({
      terms_length: terms ? terms.split(" ").length : 0
    });

    handleUpdate({ page: 1, q: terms });

  }

  render() {
    const { id, label, q } = this.props;
    const { focused, terms_length } = this.state;
    const query = q ? q : "";
    const displayMessage = terms_length ? terms_length >= 50 : query.split(" ").length >= 50;

    const fieldClass = classNames("form__field form__field--placeholder", {
      "is-dirty": query.length > 0 || focused
    });

    return (
      <div className="search__container">
        <form onSubmit={ e => this.handleSubmit(e) } noValidate className={ fieldClass }>
          <label htmlFor={ id }>{ label }</label>
          <input
            type="text"
            id={ id }
            onFocus={ this.onFocus }
            onBlur={ this.onBlur }
            defaultValue={ query || "" }
            ref={ input => this.keywordInput = input }
            onChange={ e => this.handleChange(e) }
            key={ query }
            />
          <button className="no-style" aria-label="search" onClick={ e => this.handleSubmit(e) }>{ GetIcon("search") }</button>
        </form>
        <SearchResultsMessage termsLength={ query } displayMessage={ displayMessage } />
      </div>
    );
  }
}

const { func, string, number } = PropTypes;

QueryField.propTypes= {
  handleUpdate: func,
  id: string.isRequired,
  label: string,
  q: string,
};
